import api from './api';

export const userService = {
  /**
   * Delete user (admin only)
   */
  async deleteUser(userId: string): Promise<void> {
    await api.delete(`/user/${userId}`);
  },
};
